import Axios from 'axios';
import { setupInterceptorsTo } from '../utils/axios-interceptors';


export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const CancelToken = Axios.CancelToken;

export const GloboplayAxios = (url: string) => {
    const axiosInstance = Axios.create({
        baseURL: url,
        responseType: 'arraybuffer',
    });

    setupInterceptorsTo(axiosInstance);
    return axiosInstance;
}
